import { ActionTypes } from '../constants/ActionTypes';
import { Map, fromJS } from "immutable";

const initialState = {
    total: 0,
    new: 0,
    inProcess: 0,
    resolved: 0,
    feedback: 0,
    closed: 0,
    rejected: 0
};

const overview = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_OVERVIEW:
            return getOverview(state, action);
    }

    return state;
}

function getOverview(state, action) {
    const { overview } = action;
    overview.total = 0;
    for (var prop in overview) {
        if (prop != 'total') {
            overview.total += overview[prop];
        }
    }

    return overview;
}

const initialStateByUser = Map({})

const overviewByUser = (state = initialStateByUser, action) => {
    switch (action.type) {
        case ActionTypes.GET_OVERVIEW_BY_USER:
            return getOverviewByUser(state, action);
    }

    return state;
}

function getOverviewByUser(state, action) {
    const { overview, userID } = action;
    if (userID) {
        state = state.set(userID.toString(), overview);
    }

    return state;
}

const overviewByTrackers = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_OVERVIEW_BY_TRACKER:
            return getOverviewByTrackers(state, action);
    }

    return state;
}

function getOverviewByTrackers(state, action) {
    const { trackers } = action;
    return trackers;
}

export { overview, overviewByUser, overviewByTrackers };


// WEBPACK FOOTER //
// ./src/reducers/overview.js